/**
 * Todos WebSocket plugin — declares message-type → Redux action mappings.
 * Consumed by the root WS saga via registerWsPlugin() at store-wiring time.
 * The existing WS_TODO_* handlers in sagas.ts react to the dispatched actions.
 */

import { WsPluginMap } from '@/infra/ws/root-saga';
import { Todo } from '@/infra/types/domain';

type TodoCreatedData = { todo: Todo };
type TodoUpdatedData = { id: string; full_object?: Todo; changes?: Partial<Todo> };

export const todosWsPlugin: WsPluginMap = {
  'todo.created': (msg) => {
    const data = msg.data as TodoCreatedData;
    if (!data?.todo) return null;
    return { type: 'WS_TODO_CREATED', payload: data.todo };
  },
  'todo.updated': (msg) => {
    const data = msg.data as TodoUpdatedData;
    if (!data?.id) return null;
    return { type: 'WS_TODO_UPDATED', payload: data };
  },
};
